import autoComplete from "@tarekraafat/autocomplete.js";
import { Subject, takeWhile } from "rxjs";
import { WRTopic } from "../app/Models/topic";
import { WRTile, WRTileType, WRTileTypeLabel, WRTileImageType  } from "../app/Models/tile";
import { WROption } from "../app/Models/option";

declare global {
    interface Window {
        handleFocus: any;
    }
}

interface SelectPostConfig {
    fetch_url: string;
    post_id: number;
    selector: string;
    ac_selector: string;
    eventName: string;
    multiple?: boolean;
}

// components/ExampleComponent.js
/**
 * Initialize our component here!
 */
export const inithandleFocus = () => {
    console.log("initHandleFocus");
    startFocus1();
};

/**
 * Checks if page has autocomplete component
 * @return {Boolean}
 */

const startFocus1 = () => {
    console.log("START FOCUS!");

    window.handleFocus = () => {

        return {
            tileType: WRTileType,
            tileImageType: WRTileImageType,
            tileTypeLabel: WRTileTypeLabel,
            focusStructure: [],
            ob: null,
            tab: "",
            isInit: false,
            editor: null,
            init() {
                if(!this.isInit) {
                    this.isInit = true;
                    console.log("INIT FOCUS!!", this.focusStructure);
                    this.ob = new Subject();
                    let instance1 = this;
                    this.ob.subscribe(() => {
                        instance1.json = JSON.stringify(instance1.focusStructure);
                        console.log("SUBSCRIBE", instance1.focusStructure);
    
                    });
                    let el = document.querySelector("#jsonPrev");
                    if(el!=null) {
                        let content = el.textContent;
                        if (content) {
                            this.focusStructure = [];
                            console.log("SET STRUCTURE", content);
                            this.focusStructure = JSON.parse(content);
                            console.log("STRUCTURE Length", this.focusStructure.length);
                        }
                    }
                    
                    this.ob.next();
                }
                // this.editor = wp.editor();
                
                
            },
            addTopic() {
                let item = new WRTopic("", "", new Array<WRTile>());
                this.focusStructure.push(item);
                this.ob.next();
            },
            removeTopic(item) {
                this.focusStructure.splice(this.focusStructure.indexOf(item), 1);
                this.ob.next();
            },
            moveUpTopic(item) {
                const fromIndex = this.focusStructure.indexOf(item); //
                const toIndex = fromIndex - 1;
                const element = this.focusStructure.splice(fromIndex, 1)[0];
                this.focusStructure.splice(toIndex, 0, element);
                this.ob.next();
            },
            moveDownTopic(item) {
                const fromIndex = this.focusStructure.indexOf(item); //
                const toIndex = fromIndex + 1;
                const element = this.focusStructure.splice(fromIndex, 1)[0];
                this.focusStructure.splice(toIndex, 0, element);
                this.ob.next();
            },
            addTile(topic:WRTopic, type:WRTileType) {
                let item = new WRTile("", "", "", "tile-full", "", "", "", 0, type ? type :WRTileType.BASIC, false, [new WROption(), new WROption()], "");
                if(!topic.tiles) topic.tiles = new Array<WRTile>();
                topic.tiles.push(item);
                this.ob.next();
            },
            fillTile(topic, detail) {
                let item = new WRTile(detail.title, detail.text, detail.extendedText, detail.width, detail.src, detail.video, detail.link, detail.srcid, detail.type, detail.newTab, detail.options, "");
                topic.tiles.push(item);
                this.ob.next();
            },
            removeTile(topic, tile) {
                topic.tiles.splice(topic.tiles.indexOf(tile), 1);
                this.ob.next();
            },
            moveUpTile(topic, tile) {
                const fromIndex = topic.tiles.indexOf(tile); //
                const toIndex = fromIndex - 1;
                const element = topic.tiles.splice(fromIndex, 1)[0];
                topic.tiles.splice(toIndex, 0, element);
                this.ob.next();
            },
            moveDownTile(topic, tile) {
                const fromIndex = topic.tiles.indexOf(tile); //
                const toIndex = fromIndex + 1;
                const element = topic.tiles.splice(fromIndex, 1)[0];
                topic.tiles.splice(toIndex, 0, element);
                this.ob.next();
            },
            
            deleteVideo(tile) {
                tile.video = "";
                this.ob.next();
            },
            deleteImage(tile) {
                tile.src = "";
                tile.srcid = "";
                this.ob.next();
            },
            openMedia(item, type) {
                let gal_window = wp.media({
                    title: "Hintergrundbild auswählen",
                    library: { type: type == "galery" ? "image" : type },
                    multiple: type == "galery" ? "add" : false,
                    button: { text: "auswählen" },
                });

                let curItem = item;
                let instance = this;

                gal_window.on("select", function () {
                    var u_sel = gal_window
                        .state()
                        .get("selection");
                        if(type != "galery") u_sel = u_sel.first().toJSON();
                        if(type == "galery") u_sel = u_sel.toJSON();
                    if(type == "image") {
                        curItem.src = u_sel.url;
                        curItem.srcid = u_sel.id;
                    }
                    else if(type == "galery") {
                        curItem.galery = u_sel.map(item => item.url);
                        curItem.galeryString = JSON.stringify(curItem.galery);
                        console.log("u_sel: ", curItem.galery);
                    }
                    else if(type == "video") {
                        curItem.video = u_sel.url;
                    }
                    instance.ob.next();
                });
                gal_window.open();
            },
            setTab(tab) {
                this.tab = tab;
            },
            setTileImageType(tile, imageType:WRTileImageType) {
                if(tile.imageType == null) {
                    tile.imageType = WRTileImageType.SINGLE_IMAGE;
                }
                tile.imageType = imageType;
                this.ob.next();
            },
            backendExpandTopic(topic) {
                topic.backend_expanded = !topic.backend_expanded;
                this.ob.next();
            },
            backendExpandTile(tile) {
                tile.backend_expanded = !tile.backend_expanded;
                this.ob.next();
            },
            json: "",
        };
    };
};
